import { render, staticRenderFns } from "./ReadingArea.vue?vue&type=template&id=061ab1f2"
import script from "./ReadingArea.vue?vue&type=script&lang=js"
export * from "./ReadingArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports